// src/components/Layout/Layout.tsx
import React, { FC } from "react";
import { LayoutProps } from "./Layout.props";
import Navbar from "@components/Navbar/Navbar";

import { STORAGE_KEYS } from "constants/storageKeys";
import SidebarLanding from "@components/Sidebar/SidebarLanding";
import SidebarPlatform from "@components/Sidebar/SidebarPlatform";

const Layout: FC<LayoutProps> = ({ children }) => {
	const panelType =
		localStorage.getItem(STORAGE_KEYS.ADMIN_PANEL_TYPE) || "landing";
	const Sidebar = panelType === "platform" ? SidebarPlatform : SidebarLanding;
	return (
		<div className="flex flex-col min-h-screen">
			<Navbar />

			{/* Content row below the 70px navbar */}
			<div className="flex h-[calc(100vh-10px)] pt-[70px] overflow-hidden">
				<Sidebar />

				{/* Only this scrolls */}
				<main className="flex-1 p-8 overflow-y-auto bg-bgTwoColor">
					{children}
				</main>
			</div>
		</div>
	);
};

export default Layout;
